/**
 * The reader's cursor treatments. A module of its own so both CursorOrchestrator (which decides)
 * and cursor/badSignalCursorPolicy (which it consults) can name them without importing each other:
 * the policy used to read these off the orchestrator, which closed a require cycle that was safe
 * only because the import happened to be read at call time.
 */
export const CURSOR_BEHAVIOR = Object.freeze({
  STANDARD: 'standard',        // normal cursor visible
  CURSOR_FREE: 'cursor-free',  // cursor removed, Next-button flow
  TAP_TO_READ: 'tap-to-read',  // tap-to-advance reading mode
});
